module.exports = {
  fr: "fr",
  en: "en",
  getLanguageToSwitchTo: function (currentLanguage) {
    return currentLanguage === this.fr ? this.en : this.fr
  },
}
